import React from "react";

export default function CareTeamTile({ model }) {
  const team = model.team;
  return (
    <React.Fragment>
      <div className="title">
        Care Team
        <span className="count">{team.length}</span>
      </div>
      <div className={`tile-content care-team ${team.length ? "" : "no-data"}`}>
        {team.length ? (
          team.map((member, i) => (
            <div
              className={`team-member relation-${member.relation.toLowerCase()}`}
              key={i}
            >
              <div className="name">
                <span>{member.name}</span>
              </div>
              <div className="relation">{member.relation}</div>
            </div>
          ))
        ) : (
          <div>No Care Team Members</div>
        )}
      </div>
    </React.Fragment>
  );
}
